/**
 * The enquiry book's words (owner, 13 Oct 2026: "they will also fill the
 * enquires in the app i want to see all this data who brought in which
 * enquiry what all converted upgrade and enhance the experience of complete
 * enquiry system people should be able to upload the enquiry it was converted
 * or still open").
 *
 * Who brought an enquiry in is its recorder; where it came from is its
 * source; what it is for is its channel (domain.ts); whether it came good is
 * its outcome — Open until somebody marks it Converted or Lost, every call
 * back written into its follow-up.
 */
import { HEAD_ADMIN_DESK_EMAILS, isAsmRole } from './domain.js';

/** How the enquiry reached us. PHONE and WALK_IN are the two the counter has always used. */
export const ENQUIRY_SOURCES = ['WALK_IN', 'PHONE', 'OUTBOUND_CALL', 'WHATSAPP', 'SOCIAL_MEDIA', 'REFERRAL', 'FIELD_VISIT', 'OTHER'] as const;
export type EnquirySourceKey = (typeof ENQUIRY_SOURCES)[number];
export const ENQUIRY_SOURCE_LABELS: Record<EnquirySourceKey, string> = {
  PHONE: 'They called us',
  OUTBOUND_CALL: 'We called them',
  WALK_IN: 'Walk-in',
  WHATSAPP: 'WhatsApp',
  SOCIAL_MEDIA: 'Facebook / Instagram',
  REFERRAL: 'Referral',
  FIELD_VISIT: 'Field visit',
  OTHER: 'Other',
};

export const ENQUIRY_OUTCOMES = ['OPEN', 'WON', 'LOST'] as const;
export type EnquiryOutcomeKey = (typeof ENQUIRY_OUTCOMES)[number];
/** WON is "Converted" on every screen — the owner's word. */
export const ENQUIRY_OUTCOME_LABELS: Record<EnquiryOutcomeKey, string> = {
  OPEN: 'Open',
  WON: 'Converted',
  LOST: 'Lost',
};

/** Why one was lost — offered as a tap, and any other words are kept as written. */
export const ENQUIRY_LOST_REASONS = ['Price too high', 'Bought elsewhere', 'Not interested now', 'No response', 'Finance not approved', 'Other'] as const;

export const ENQUIRY_NOTE_MAX = 2000;

/**
 * Who reads every enquiry (owner, 13 Oct 2026: "make sure all the enquires are
 * shown only to me nobody can see each other enquires"): the owner's own
 * head-admin desks, and nobody else. Everyone else — a telecaller, an ASM, the
 * store counter, an administrator — sees only the enquiries they brought in.
 */
export function readsEveryEnquiry(user: { email: string } | null | undefined): boolean {
  return Boolean(user) && HEAD_ADMIN_DESK_EMAILS.includes(user!.email.trim().toLowerCase());
}

/** The telecalling team (13 Oct 2026). */
export function isTelecaller(roleKey: string | null | undefined): boolean {
  return roleKey === 'TELECALLER';
}

/**
 * Who keeps the enquiry book: whoever may sell (the store counter, the office)
 * and every ASM. Not the telecalling team: they call the owner's lead sheets
 * and write no enquiries of their own (owner, 13 Oct 2026: "they will not
 * upload enquires") — see leads.ts.
 */
export function keepsEnquiries(user: { roleKey: string | null | undefined; permissions: readonly string[] }): boolean {
  return user.permissions.includes('vehicles:sell') || isAsmRole(user.roleKey);
}

/**
 * A phone number as the book compares it: its last ten digits, so "+91 98390
 * 12345", "098390-12345" and "9839012345" are one person. Null when there are
 * fewer than ten digits to compare.
 */
export function phoneKey(phone: string | null | undefined): string | null {
  const digits = (phone ?? '').replace(/\D/g, '');
  return digits.length >= 10 ? digits.slice(-10) : null;
}
